import { useState } from "react";
import { toast } from "react-toastify";
import { callApiDam } from "../../api";
import { useAuth } from "../useAuth";

export default () => {
  const { selectedBusiness } = useAuth();
  const [fileList, setFileList] = useState([]);
  const [overlay, setOverlay] = useState(false);

  const getAllImages = async () => {
    setOverlay(true);
    const res = await callApiDam(
      `${process.env.REACT_APP_BILLING_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=getallimages/:NID:`
    );
    if (res === undefined) {
      // const getimg = async () => {
      //   console.log("asking for images");
      //   res = await callApiDam(
      //     `${process.env.REACT_APP_MOBILE_APP_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=getallimages/:BID:`
      //   );
      //   if (res && res.length) clearInterval(handle);
      //   setFileList(res);
      // };
      // var handle = setInterval(getimg, 1000);
    }
    if (res && res.length) {
      setFileList(res);
      setOverlay(false);
    } else {
      setFileList([]);
      toast.success("No images found");
      setOverlay(false);
    }
  };

  const uploadImage = async (data) => {
    setOverlay(true);
    const res = await callApiDam(
      `${process.env.REACT_APP_MOBILE_APP_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=uploader/:NID:`,
      "POST",
      data
    );
    setOverlay(false);
    return res;
  };

  const updateImageList = async (data) => {
    setFileList(data);
  };

  const addImage = async (data) => {
    const _temp = fileList;
    _temp.push(data);
    setFileList(_temp);
    // console.log("updated file list", fileList, data);
    // getAllImages();
  };

  const updateName = async (data) => {
    const res = await callApiDam(
      `${process.env.REACT_APP_MOBILE_APP_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=updatename/:NID:`,
      "POST",
      data
    );
    return res;
  };

  const removeTag = async (data) => {
    const res = await callApiDam(
      `${process.env.REACT_APP_MOBILE_APP_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=deletetag/:NID:`,
      "POST",
      data
    );
    return res;
  };

  const updateTag = async (data) => {
    const res = await callApiDam(
      `${process.env.REACT_APP_MOBILE_APP_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=updatetag/:NID:`,
      "POST",
      data
    );
    return res;
  };

  const deleteImage = async (data) => {
    const res = await callApiDam(
      `${process.env.REACT_APP_MOBILE_APP_BACKEND_URL}/${selectedBusiness.id}/dam-server?dest=deleteimage/:NID:`,
      "POST",
      data
    );
    return res;
  };

  // useEffect(() => {
  //   runWithGuard(getAllImages);
  // }, [selectedBusiness.id]);

  return {
    fileList,
    setFileList,
    overlay,
    getAllImages,
    uploadImage,
    updateImageList,
    addImage,
    deleteImage,
    updateName,
    updateTag,
    removeTag,
  };
};
